/* Fuse homepage — review carousel arrows. Swipe works natively via scroll-snap. */
(function () {
  function init(root) {
    var track = root.querySelector('[data-fh-track]');
    if (!track || track.dataset.fhReady) return;
    track.dataset.fhReady = '1';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function go(dir) {
      var card = track.querySelector('li');
      var step = (card ? card.clientWidth : 320) + 24;
      track.scrollBy({ left: dir * step, behavior: reduce ? 'auto' : 'smooth' });
    }
    var prev = root.querySelector('[data-fh-prev]');
    var next = root.querySelector('[data-fh-next]');
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
  }
  function all() { document.querySelectorAll('.fuse-home').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();